module.exports = __webpack_public_path__ + "static/quote-2d32c1c0ce138097171ecfed083e511d.svg";